import { Component } from 'react';
import { StaticValues } from '../../../../../../../../insfrastructure/services/static_values';
import { createCompanyManager } from '../../../../../../../../insfrastructure/services/companies';
import {
  CNPJValidator,
  CPFValidator,
  emptyField,
  ErrorMessage,
  errorsLength,
  formatErrors,
  validateDate,
  validateEmail,
  validatePasswordConfirmation
} from '../../../../../../../../insfrastructure/utils/form-validators';
import { Input } from '../../../../../../../components/input';
import { Select } from '../../../../../../../components/select';
import { DateOfBirthField } from '../../../../../../../components/date-of-birth-field';
import ResponseModal from '../../../../../../../components/response-modal';
import documentIcon from '../../../../../../../../assets/icons/document.png';
import emailIcon from '../../../../../../../../assets/icons/email.png';
import fullPersonIcon from '../../../../../../../../assets/icons/full_person.png';
import passwordIcon from '../../../../../../../../assets/icons/password.png';
import profileIcon from '../../../../../../../../assets/icons/profile.png';
import infoIcon from '../../../../../../../../assets/icons/info.png';
import './styles.sass';
import { PasswordRequirements } from '../../../../../../../components/password-requirements';
import { formatDateOnly } from '../../../../../../../../insfrastructure/utils/date-formatter';

type Props = {
  navigate: any;
  cnpj: string;
  companyName: string;
  onBack?: () => void;
};

export class CompanyManagerSignUp extends Component<Props> {
  state: any = {
    form: {
      cnpj: '',
      full_name: '',
      manager_email: '',
      cpf: '',
      date_of_birth: '',
      gender: '',
      password: '',
      password_confirmation: ''
    },
    formErrors: {},
    genderOptions: [],
    responseData: null,
    loading: false,
    isPasswordValidated: false
  };

  componentDidMount() {
    this.getStaticValues();
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.cnpj && this.props.cnpj !== prevProps.cnpj && this.state.form.cnpj !== this.props.cnpj) {
      this.setState({ form: { ...this.state.form, cnpj: this.props.cnpj } });
    }
  }

  getStaticValues = async () => {
    try {
      setTimeout(() => {
        const staticValues = JSON.parse(localStorage.getItem('static_values') + '') as StaticValues;
        if (!staticValues || !staticValues.gender) {
          console.error('Static values ou gender não encontrado');
          return;
        }

        const genderOptions = Object.keys(staticValues.gender)
          .map((key: any) => ({ value: key, label: staticValues.gender[key] }))
          .sort((a, b) => a.label.localeCompare(b.label));

        this.setState({ genderOptions });
      }, 1000);
    } catch (error) {
      console.error('Erro ao carregar valores estáticos:', error);
    }
  };

  onSubmit = async () => {
    if (this.state.loading) return;

    const cnpjValue = this.props.cnpj || this.state.form.cnpj;
    const formattedDateOfBirth = this.state.form.date_of_birth ? formatDateOnly(this.state.form.date_of_birth) : undefined;
    const validatedDateOfBirth = typeof formattedDateOfBirth === 'string'
      && /^\d{4}-\d{2}-\d{2}$/.test(formattedDateOfBirth)
      && validateDate(formattedDateOfBirth) === ''
      ? formattedDateOfBirth
      : undefined;
    const errors = formatErrors({
      cnpj: [emptyField(cnpjValue, 'string'), CNPJValidator(cnpjValue)],
      full_name: [emptyField(this.state.form.full_name, 'string')],
      manager_email: [validateEmail(this.state.form.manager_email)],
      cpf: [emptyField(this.state.form.cpf, 'string'), CPFValidator(this.state.form.cpf)],
      date_of_birth: [emptyField(this.state.form.date_of_birth, 'string'), this.state.form.date_of_birth ? (validatedDateOfBirth ? '' : 'Data inválida') : ''],
      gender: [emptyField(this.state.form.gender, 'string')],
      password: [emptyField(this.state.form.password, 'string')],
      password_confirmation: [
        emptyField(this.state.form.password_confirmation, 'string'),
        validatePasswordConfirmation(this.state.form.password, this.state.form.password_confirmation)
      ]
    });

    this.setState({ formErrors: errors });

    if (errorsLength(errors) > 0 || !this.state.isPasswordValidated) return;

    try {
      this.setState({ loading: true });

      const payload = {
        cnpj: this.props.cnpj || this.state.form.cnpj,
        full_name: this.state.form.full_name,
        manager_email: this.state.form.manager_email,
        password: this.state.form.password,
        cpf: this.state.form.cpf,
        date_of_birth: validatedDateOfBirth,
        gender: this.state.form.gender
      };

      await createCompanyManager(payload as any);
      this.props.navigate('/sign-up/company/confirmation/request', { state: { email: this.state.form.manager_email, pendingApproval: true } });
    } catch (error: any) {
      let errorsText: string[] = [];
      const responsePayload = error?.response?.data;

      if (responsePayload) {
        if (responsePayload['manager_email']) {
          errorsText.push('Email já cadastrado');
        }
        if (responsePayload['cpf']) {
          errorsText.push('CPF já cadastrado');
        }
        if (responsePayload['cnpj']) {
          errorsText.push('CNPJ inválido');
        }
      }

      if (errorsText.length === 0) {
        errorsText.push('Erro ao processar cadastro. Tente novamente.');
      }

      const responseData = {
        type: 'error',
        title: 'Erro ao cadastrar',
        text: () => (
          <>
            {errorsText.map((item: string) => (
              <p key={item}>{item}</p>
            ))}
          </>
        )
      };

      this.setState({ loading: false, responseData });
    }
  };

  handleLegacyFlow = () => {
    this.props.navigate('/sign-up/company?flow=legacy');
  };

  render() {
    return (
      <div className='form company-manager-signup company-user'>
        <div className='form-container'>
          <div className='text'>
            <h4>Bem vindo(a) recrutador(a).</h4>
            <p>Este perfil é para você que busca contratar mecânicos para uma empresa parceira já cadastrada.</p>
          </div>
          <div className='columns'>
            <div className='column'>
              <div className='field-group'>
                <Input
                  name='cnpj'
                  label='CNPJ da minha empresa'
                  icon={documentIcon}
                  required={true}
                  mask='99.999.999/9999-99'
                  value={this.props.cnpj || this.state.form.cnpj}
                  onChange={e => this.setState({ form: { ...this.state.form, cnpj: e }, formErrors: { ...this.state.formErrors, cnpj: [] } })}
                  disabled={!!this.props.cnpj}
                />
                <ErrorMessage errors={this.state.formErrors['cnpj']} />
                {this.props.companyName && (
                  <p className='company-lookup-status success'>
                    Empresa encontrada: <span className='company-name'>{this.props.companyName}</span>
                  </p>
                )}
              </div>
              <div className='field-group'>
                <Input
                  name='full_name'
                  label='Nome Completo'
                  icon={profileIcon}
                  required={true}
                  value={this.state.form.full_name}
                  onChange={e => this.setState({ form: { ...this.state.form, full_name: e } })}
                />
                <ErrorMessage errors={this.state.formErrors['full_name']} />
              </div>
              <div className='field-group'>
                <Input
                  name='manager_email'
                  label='E-mail'
                  icon={emailIcon}
                  required={true}
                  value={this.state.form.manager_email}
                  onChange={e => this.setState({ form: { ...this.state.form, manager_email: e } })}
                />
                <ErrorMessage errors={this.state.formErrors['manager_email']} />
              </div>
              <div className='field-group'>
                <Input
                  name='cpf'
                  label='CPF'
                  icon={documentIcon}
                  mask='999.999.999-99'
                  required={true}
                  value={this.state.form.cpf}
                  onChange={e => this.setState({ form: { ...this.state.form, cpf: e } })}
                />
                <ErrorMessage errors={this.state.formErrors['cpf']} />
              </div>
              <div className='field-group'>
                <DateOfBirthField
                  name='date_of_birth'
                  required={true}
                  value={this.state.form.date_of_birth}
                  onChange={e => this.setState({ form: { ...this.state.form, date_of_birth: e } })}
                  errors={this.state.formErrors['date_of_birth']}
                />
              </div>
              <div className='field-group'>
                <Select
                  name='gender'
                  label='Gênero'
                  icon={fullPersonIcon}
                  required={true}
                  options={this.state.genderOptions}
                  value={this.state.form.gender}
                  onChange={e => this.setState({ form: { ...this.state.form, gender: e } })}
                />
                <ErrorMessage errors={this.state.formErrors['gender']} />
              </div>
            </div>
            <div className='column'>
              <div className='field-group'>
                <Input
                  name='password'
                  label='Senha'
                  type='password'
                  icon={passwordIcon}
                  required={true}
                  value={this.state.form.password}
                  onChange={e => this.setState({ form: { ...this.state.form, password: e } })}
                />
                <ErrorMessage errors={this.state.formErrors['password']} />
              </div>
              <div className='field-group'>
                <Input
                  name='password_confirmation'
                  label='Repita a senha'
                  type='password'
                  icon={passwordIcon}
                  required={true}
                  value={this.state.form.password_confirmation}
                  onChange={e => this.setState({ form: { ...this.state.form, password_confirmation: e } })}
                />
                <ErrorMessage errors={this.state.formErrors['password_confirmation']} />
              </div>
              <PasswordRequirements
                password={this.state.form.password}
                email={this.state.form.manager_email}
                isPasswordValidated={isPasswordValidated => this.setState({ isPasswordValidated })}
              />
              <div className='pending-info'>
                <div className='info-icon'>
                  <img src={infoIcon} alt='Informação' />
                </div>
                <div className='info-text'>
                  <p>
                    Sua solicitação será analisada pela equipe Emprega Mecânico.
                    Você receberá um e-mail com o status da solicitação.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className='submit-block'>
            <div>
              <p>
                Não se preocupe, suas informações estão seguras conosco. Seu CPF será usado para assegurar seu cadastro
                único e seus dados não serão compartilhado com os candidatos.
              </p>
            </div>
            <div style={{ width: '50%', display: 'flex', alignItems: 'center' }}>
              <div className='columns' style={{ borderBottom: 'none', borderTop: 'none', width: '100%', alignItems: 'center' }}>
                {this.props.onBack ? (
                  <>
                    <div className='column' style={{ borderRight: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                      <button className='secondary submit' onClick={this.props.onBack} style={{ width: '100%', margin: 0, border: '1px solid #105099' }}>Voltar</button>
                    </div>
                    <div className='column' style={{ borderRight: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                      <button className='primary submit' onClick={this.onSubmit} style={{ width: '100%', margin: 0 }}>
                        { !this.state.loading ? 'Continuar' : 'Enviando...' }
                      </button>
                    </div>
                  </>
                ) : (
                  <div className='column' style={{ borderRight: 'none', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '18px' }}>
                    <button className='primary submit' onClick={this.onSubmit} style={{ width: '100%', margin: 0 }}>
                      { !this.state.loading ? 'Continuar' : 'Enviando...' }
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <ResponseModal
          render={this.state.responseData}
          type={this.state.responseData?.type}
          title={this.state.responseData?.title}
          text={this.state.responseData?.text}
          onClose={() => this.setState({ responseData: null })}
        />
      </div>
    );
  }
}
